import {
    Axios
  } from '@/utils/from-common';
 
  // 搜索记录
  export const Earnings_List = (param) => Axios('POST', '/bms/earnings/EarningsList', param);
  export const Earnings_Import = (param) => Axios('POST', '/bms/earnings/EarningsImport', param);
  export const Earnings_Info = (param) => Axios('POST', '/bms/earnings/EarningsInfo', param);